import { render, staticRenderFns } from "./RuleLogs.vue?vue&type=template&id=a1535622&scoped=true&"
import script from "./RuleLogs.vue?vue&type=script&lang=ts&"
export * from "./RuleLogs.vue?vue&type=script&lang=ts&"
import style0 from "./RuleLogs.vue?vue&type=style&index=0&id=a1535622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1535622",
  null
  
)

export default component.exports